import { motion } from "framer-motion";
import { SERVICES } from "@/lib/brand";
import { Reveal } from "@/components/Reveal";
import { useLang } from "@/lib/i18n";

export default function Services() {
  const { t } = useLang();
  return (
    <section
      id="services"
      className="relative py-24 md:py-32 bg-white"
      data-testid="services-section"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <p className="text-[#1478FF] font-semibold tracking-[0.28em] uppercase text-xs mb-5">
            {t.services.eyebrow}
          </p>
        </Reveal>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <Reveal delay={0.05}>
            <h2 className="font-display font-semibold text-neutral-900 text-4xl md:text-6xl tracking-tight leading-[0.95]">
              {t.services.title}
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="text-neutral-600 max-w-sm text-sm md:text-base">
              {t.services.subtitle}
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-12 gap-4">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            const highlight = i === 0;
            const item = t.services.items[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{
                  duration: 0.6,
                  delay: (i % 3) * 0.08,
                  ease: [0.22, 1, 0.36, 1],
                }}
                whileHover={{ y: -6 }}
                className={`group relative border p-7 md:p-8 overflow-hidden ${s.span} ${
                  highlight
                    ? "bg-[#1478FF] border-[#1478FF] min-h-[260px] flex flex-col justify-end"
                    : "bg-white border-black/10 hover:border-[#1478FF]/60 shadow-[0_1px_0_rgba(0,0,0,0.02)] hover:shadow-[0_10px_28px_-14px_rgba(20,120,255,0.25)]"
                }`}
                data-testid={`service-card-${i}`}
              >
                {!highlight && (
                  <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 blue-glow opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                )}
                <span
                  className={`relative inline-flex h-12 w-12 items-center justify-center mb-6 ${
                    highlight ? "bg-neutral-900 text-[#1478FF]" : "bg-[#1478FF] text-white"
                  }`}
                >
                  <Icon size={22} />
                </span>
                <h3
                  className={`relative font-display font-semibold text-xl md:text-2xl tracking-tight ${
                    highlight ? "text-white" : "text-neutral-900"
                  }`}
                >
                  {item.title}
                </h3>
                <p
                  className={`relative mt-2.5 text-sm leading-relaxed ${
                    highlight ? "text-blue-50/90" : "text-neutral-600"
                  }`}
                >
                  {item.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
